import { ColumnHeaderDateFilter } from "components/ReusableHeaderFilter/ColumnHeaderDateFilter";
import { Task1120TrackerFilterType } from "../Task1120TrackerFilter";
import {
  FILTER_END_DATE,
  FILTER_FORM_1120_COMPLETED_END_DATE,
  FILTER_FORM_1120_COMPLETED_SELECT_PERIOD,
  FILTER_FORM_1120_COMPLETED_START_DATE,
  FILTER_SELECT_PERIOD,
  FILTER_START_DATE,
} from "../Task1120FilterOptions";

const Form1120CompletedOnColumnHeader = ({
  values,
  updateFilter,
}: Omit<Task1120TrackerFilterType, "updateFilter"> & {
  updateFilter: (name: string, value: string) => void;
}) => {
  const isActive = Boolean(
    values.FORM_1120_COMPLETED_START_DATE || values.FORM_1120_COMPLETED_END_DATE
  );

  const handleClearFilter = () => {
    updateFilter(FILTER_FORM_1120_COMPLETED_START_DATE, "");
    updateFilter(FILTER_FORM_1120_COMPLETED_END_DATE, "");
    updateFilter(FILTER_FORM_1120_COMPLETED_SELECT_PERIOD, "");
  };

  const handleDateChange = (name: string, value: string) => {
    switch (name) {
      case FILTER_START_DATE:
        updateFilter(FILTER_FORM_1120_COMPLETED_START_DATE, value);
        break;
      case FILTER_END_DATE:
        updateFilter(FILTER_FORM_1120_COMPLETED_END_DATE, value);
        break;
      case FILTER_SELECT_PERIOD:
        updateFilter(FILTER_FORM_1120_COMPLETED_SELECT_PERIOD, value);
        break;
      default:
        break;
    }
  };

  const dateValues = {
    START_DATE: values.FORM_1120_COMPLETED_START_DATE,
    END_DATE: values.FORM_1120_COMPLETED_END_DATE,
    SELECT_PERIOD: values.FORM_1120_COMPLETED_SELECT_PERIOD,
  };

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>1120 Completed On</div>
      <ColumnHeaderDateFilter
        isActive={isActive}
        values={dateValues}
        updateFilter={handleDateChange}
        handleClearFilter={handleClearFilter}
      />
    </div>
  );
};

export default Form1120CompletedOnColumnHeader;
